class InputFile {
  private el: HTMLElement;
  private targetEl: HTMLElement | null;
  private defaultValue: string = '';
  constructor(el: HTMLElement) {
    this.el = el;
    this.targetEl = this.el.querySelector('[data-file-target]');
    this.defaultValue = (this as any).targetEl?.innerHTML;
    this.init();
  }

  private init() {
    this.el.addEventListener('change', (e: any) => {
      let value = e.target.value.split('\\');
      if ((this as any).targetEl) {
        if (e.target.value === '') {
          (this as any).targetEl.innerHTML = this.defaultValue;
        } else {
          (this as any).targetEl.innerHTML = value[value.length - 1];
        }
      }
    });
  }
}

export default InputFile;
